"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GoToProduct = require("./GoToProduct");
Object.keys(_GoToProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GoToProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GoToProduct[key];
    }
  });
});
//# sourceMappingURL=index.js.map